module.exports = __webpack_public_path__ + "img/silae-papillon.64b19b41.svg";